import { atom } from 'recoil';

export const cookieBannerResolvedState = atom({
  key: 'privacy:cookieBannerResolved',
  default: false,
});

export const cookieBannerResolvedBeforeSessionState = atom({
  key: 'privacy:cookieBannerResolvedBeforeSession',
  default: false,
});

export const cookieLoginCtaShownState = atom({
  key: 'privacy:cookieLoginCtaShown',
  default: false,
});
